import React, { useMemo, useState } from "react";
import {
    Search,
    Eye,
    X,
    RotateCcw,
    Users,
    CalendarDays,
    CalendarRange,
} from "lucide-react";

const initialEnquiries = [
    {
        id: 1,
        name: "Ramesh Kumar",
        mobile: "9876543201",
        pinCode: "638001",
        address: "Erode, Tamil Nadu",
        createdDate: "2026-10-05",
    },
    {
        id: 2,
        name: "Meena S",
        mobile: "9876543202",
        pinCode: "641001",
        address: "Coimbatore, Tamil Nadu",
        createdDate: "2026-10-05",
    },
    {
        id: 3,
        name: "Sathish M",
        mobile: "9876543203",
        pinCode: "636007",
        address: "Salem, Tamil Nadu",
        createdDate: "2026-10-04",
    },
    {
        id: 4,
        name: "Lakshmi Devi",
        mobile: "9876543204",
        pinCode: "641602",
        address: "Tiruppur, Tamil Nadu",
        createdDate: "2026-10-03",
    },
    {
        id: 5,
        name: "Vijay R",
        mobile: "9876543205",
        pinCode: "638004",
        address: "Perundurai, Erode, Tamil Nadu",
        createdDate: "2026-10-02",
    },
    {
        id: 6,
        name: "Priyanka R",
        mobile: "9876543206",
        pinCode: "638011",
        address: "Bhavani, Erode, Tamil Nadu",
        createdDate: "2026-10-01",
    },
];

function BranchEnquiries() {
    const [enquiries] = useState(initialEnquiries);

    const [searchType, setSearchType] =
        useState("name");

    const [searchText, setSearchText] =
        useState("");

    const [viewEnquiry, setViewEnquiry] =
        useState(null);

    const today = "2026-10-05";

    const filteredEnquiries = useMemo(() => {
        const search = searchText
            .trim()
            .toLowerCase();

        if (!search) {
            return enquiries;
        }

        return enquiries.filter((enquiry) => {
            if (searchType === "name") {
                return enquiry.name
                    .toLowerCase()
                    .includes(search);
            }

            if (searchType === "mobile") {
                return enquiry.mobile.includes(search);
            }

            if (searchType === "pinCode") {
                return enquiry.pinCode.includes(search);
            }

            return true;
        });
    }, [
        enquiries,
        searchText,
        searchType,
    ]);

    const totalEnquiries =
        enquiries.length;

    const todayEnquiries =
        enquiries.filter(
            (item) =>
                item.createdDate === today
        ).length;

    const currentMonthEnquiries =
        enquiries.filter((item) =>
            item.createdDate.startsWith("2026-10")
        ).length;

    const clearSearch = () => {
        setSearchText("");
        setSearchType("name");
    };

    return (
        <div className="branch-enquiries-page">

            {/* PAGE HEADER */}

            <div className="page-header">

                <div>
                    <h1>
                        Branch Enquiries
                    </h1>

                    <p>
                        Manage branch registration
                        enquiries
                    </p>
                </div>

            </div>

            {/* SUMMARY CARDS */}

            <div className="enquiry-summary enquiry-summary-three">

                <div className="enquiry-summary-card">

                    <div className="enquiry-summary-icon blue">
                        <Users size={20} />
                    </div>

                    <div>
                        <span>
                            Total Enquiries
                        </span>

                        <strong>
                            {totalEnquiries}
                        </strong>
                    </div>

                </div>

                <div className="enquiry-summary-card">

                    <div className="enquiry-summary-icon green">
                        <CalendarDays size={20} />
                    </div>

                    <div>
                        <span>
                            Today Enquiries
                        </span>

                        <strong>
                            {todayEnquiries}
                        </strong>
                    </div>

                </div>

                <div className="enquiry-summary-card">

                    <div className="enquiry-summary-icon purple">
                        <CalendarRange size={20} />
                    </div>

                    <div>
                        <span>
                            This Month
                        </span>

                        <strong>
                            {currentMonthEnquiries}
                        </strong>
                    </div>

                </div>

            </div>

            {/* SEARCH */}

            <div className="enquiry-filter-card">

                <div className="enquiry-search-row">

                    <div className="enquiry-search-type">

                        <select
                            value={searchType}
                            onChange={(e) =>
                                setSearchType(
                                    e.target.value
                                )
                            }
                        >
                            <option value="name">
                                Name
                            </option>

                            <option value="mobile">
                                Mobile Number
                            </option>

                            <option value="pinCode">
                                PIN Code
                            </option>
                        </select>

                    </div>

                    <div className="enquiry-search-box">

                        <Search size={18} />

                        <input
                            type="text"
                            value={searchText}
                            onChange={(e) =>
                                setSearchText(
                                    e.target.value
                                )
                            }
                            placeholder={`Search ${
                                searchType ===
                                "name"
                                    ? "Name"
                                    : searchType ===
                                      "mobile"
                                    ? "Mobile Number"
                                    : "PIN Code"
                            }...`}
                        />

                        {searchText && (
                            <button
                                className="enquiry-search-clear"
                                onClick={() =>
                                    setSearchText("")
                                }
                            >
                                <X size={16} />
                            </button>
                        )}

                    </div>

                    <button
                        className="enquiry-reset-btn"
                        onClick={clearSearch}
                    >
                        <RotateCcw size={16} />
                        Reset
                    </button>

                </div>

            </div>

            {/* TABLE */}

            <div className="enquiries-table-card">

                <div className="enquiry-table-header">

                    <div>

                        <h2>
                            Branch Registration
                            Enquiries
                        </h2>

                        <span>
                            Showing{" "}
                            {
                                filteredEnquiries.length
                            }{" "}
                            of{" "}
                            {enquiries.length}{" "}
                            enquiries
                        </span>

                    </div>

                </div>

                <div className="enquiries-table-wrapper">

                    <table className="enquiries-table">

                        <thead>

                            <tr>

                                <th>
                                    S.No
                                </th>

                                <th>
                                    Name
                                </th>

                                <th>
                                    Mobile Number
                                </th>

                                <th>
                                    PIN Code
                                </th>

                                <th>
                                    Address
                                </th>

                                <th>
                                    Action
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {filteredEnquiries.length ===
                            0 ? (
                                <tr>

                                    <td
                                        colSpan="6"
                                        className="enquiry-empty-table"
                                    >
                                        No enquiries
                                        found
                                    </td>

                                </tr>
                            ) : (
                                filteredEnquiries.map(
                                    (
                                        enquiry,
                                        index
                                    ) => (
                                        <tr
                                            key={
                                                enquiry.id
                                            }
                                        >

                                            <td>
                                                {index +
                                                    1}
                                            </td>

                                            <td>

                                                <div className="enquiry-name">

                                                    <div className="enquiry-avatar">
                                                        {enquiry.name
                                                            .charAt(
                                                                0
                                                            )
                                                            .toUpperCase()}
                                                    </div>

                                                    <strong>
                                                        {
                                                            enquiry.name
                                                        }
                                                    </strong>

                                                </div>

                                            </td>

                                            <td>
                                                {
                                                    enquiry.mobile
                                                }
                                            </td>

                                            <td>
                                                {
                                                    enquiry.pinCode
                                                }
                                            </td>

                                            <td className="enquiry-address">
                                                {
                                                    enquiry.address
                                                }
                                            </td>

                                            <td>

                                                <button
                                                    className="enquiry-view-btn"
                                                    title="View Enquiry"
                                                    onClick={() =>
                                                        setViewEnquiry(
                                                            enquiry
                                                        )
                                                    }
                                                >
                                                    <Eye
                                                        size={
                                                            17
                                                        }
                                                    />
                                                </button>

                                            </td>

                                        </tr>
                                    )
                                )
                            )}

                        </tbody>

                    </table>

                </div>

            </div>

            {/* VIEW MODAL */}

            {viewEnquiry && (
                <div className="enquiry-modal-overlay">

                    <div className="enquiry-view-modal enquiry-simple-modal">

                        <div className="enquiry-modal-header">

                            <div>
                                <h2>
                                    New Registration
                                    Enquiry
                                </h2>

                                <p>
                                    Enquiry Details
                                </p>
                            </div>

                            <button
                                onClick={() =>
                                    setViewEnquiry(
                                        null
                                    )
                                }
                            >
                                <X size={20} />
                            </button>

                        </div>

                        {/* CUSTOMER */}

                        <div className="enquiry-profile-header">

                            <div className="enquiry-large-avatar">
                                {viewEnquiry.name
                                    .charAt(0)
                                    .toUpperCase()}
                            </div>

                            <div>

                                <h3>
                                    {
                                        viewEnquiry.name
                                    }
                                </h3>

                                <p>
                                    {
                                        viewEnquiry.mobile
                                    }
                                </p>

                            </div>

                        </div>

                        {/* DETAILS */}

                        <div className="enquiry-detail-section">

                            <h3>
                                Enquiry Information
                            </h3>

                            <div className="enquiry-detail-grid">

                                <EnquiryInfo
                                    label="Name"
                                    value={
                                        viewEnquiry.name
                                    }
                                />

                                <EnquiryInfo
                                    label="Mobile Number"
                                    value={
                                        viewEnquiry.mobile
                                    }
                                />

                                <EnquiryInfo
                                    label="PIN Code"
                                    value={
                                        viewEnquiry.pinCode
                                    }
                                />

                                <div className="enquiry-info-item enquiry-address-info">

                                    <span>
                                        Address
                                    </span>

                                    <strong>
                                        {
                                            viewEnquiry.address
                                        }
                                    </strong>

                                </div>

                            </div>

                        </div>

                        <div className="enquiry-modal-footer">

                            <button
                                className="secondary-btn"
                                onClick={() =>
                                    setViewEnquiry(
                                        null
                                    )
                                }
                            >
                                Close
                            </button>

                        </div>

                    </div>

                </div>
            )}

        </div>
    );
}

function EnquiryInfo({
    label,
    value,
}) {
    return (
        <div className="enquiry-info-item">

            <span>
                {label}
            </span>

            <strong>
                {value || "-"}
            </strong>

        </div>
    );
}

export default BranchEnquiries;